import client, { url } from './client';
import qs from 'qs';

export const loadTrapAppStats = ({ socketKey, date }) => {
  const queryString = qs.stringify({
    socketKey,
    date,
  });
  return client.get(`${url}/api/trapstats?${queryString}`);
};

export const loadTrapAppMonthlyStats = ({ socketKey, month }) => {
  const queryString = qs.stringify({
    socketKey,
    month,
  });
  return client.get(`${url}/api/trapstats/monthly?${queryString}`);
};
